export default {
  home: "Inicio",
  shopLocal: "Compre VE locales",
  shopDealers: "Distribuidores de tiendas",
  viewVehicleDetails: "Ver detalles del vehículo",
  browseInventory: "Explorar inventario cercano",
  dealerDirectory: "Directorio de distribuidores",
  evFacts: "Hechos de los VE",
  faq: "Preguntas Frecuentes",
  electricVehicles: "Autos Eléctricos",
  usedElectricVehicles: "Autos Eléctricos Usados",
  compareVehicles: "Compare Vehículos",
  incentives: "Incentivos",
  chargingStations: "Estaciones de Carga",
  homeChargers: "Cargadores Caseros",
  dealers: "Distribuidores",
  newVehicles: "Autos Nuevos",
  electricians: "Electricistas",

  electricity: "Fuente",
  gasoline: "Gasolina",
  total: "Total",
  description: "Descripción",
  detailedCalculations: "detalles del cálculo",
  charging: "Carga",
  emissions: "Emisiones",
  source: "Fuente",
  vehicles: "Vehículos",
  make: "Marca",
  model: "Modelo",
  all: "Todos",
  age: "Años",
  zipcode: "Código Postal",

  "homepage.bigPromise.title": "Descubra, Ahorre y Cargue Adelante.",
  "homepage.bigPromise.description":
    "Esta guía puede ayudarle a tomar una decisión informada al proporcionar información detallada sobre los vehículos eléctricos, el ahorro y la carga.",
  "homepage.bigPromise.findYourEvMatch": "Encuentre su pareja de VE",
  "homepage.bigPromise.seeYourRebates": "Vea sus Reembolsos",
  "homepage.bigPromise.howChargingWorks": "Cómo Funciona la Carga",

  faqTitle: "¿Por qué conducir eléctrico?",
  faqDescription:
    "Conducir un VE conlleva grandes beneficios: para su bolsillo, su experiencia de conducción y el medio ambiente.",

  "ae-erides-bikemap-faq1": "Mapa de bicicletas de Austin",
  "ae-erides-bikemap-faq1-a":
    "Explora los carriles y senderos para bicicletas en crecimiento de Austin.",

  "ae-faq1": "🚗💵 Ahorre Dinero en Cada Milla",
  "ae-faq1A":
    "Los VE son más baratos de operar que los autos de gasolina. La electricidad cuesta menos que la gasolina, y los VE utilizan la energía de manera más eficiente, lo que le ayuda a avanzar más lejos por menos.",
  "ae-faq2": "🛠️ Menos Mantenimiento, Más Tranquilidad",
  "ae-faq2A":
    "Sin cambios de aceite. Menos piezas móviles. Los VE requieren menos mantenimiento, lo que le ahorra tiempo y dinero en reparaciones.",
  "ae-faq3": "😊 Una Mejor Experiencia de Conducción",
  "ae-faq3A":
    "Experimente la emoción de la aceleración instantánea y la maniobrabilidad receptiva. Los VE son silenciosos, potentes y extremadamente divertidos de conducir, ya sea que esté en su viaje diario o disfrutando de un paseo de fin de semana.",
  "ae-faq4": "🌿🏙️ Más Limpio para la Comunidad",
  "ae-faq4A":
    "Los VE no producen emisiones contaminantes, lo que significa aire más limpio y menos gases de efecto invernadero en nuestra ciudad. Al elegir lo eléctrico, está contribuyendo activamente a los objetivos climáticos de Austin.",
  "ae-faq5": "🔌🏠🛣️ Carga en Casa o en el Camino",
  "ae-faq5A":
    "Conéctalo por la noche en casa o usa la creciente red de estaciones públicas de carga en Austin, incluidas las de carga rápida.",

  "ae-faq6": "🎁 Recibe Recompensas por Conducir Eléctrico",
  "ae-faq6A":
    "Aprovecha los créditos fiscales federales y los reembolsos de Austin Energy para hacer que tener un vehículo eléctrico sea aún más accesible. Si eres como la mayoría de las personas y conduces alrededor de 30 millas al día, un vehículo eléctrico podría significar más dinero en tu bolsillo y más tiempo para lo que importa.",

  "ae-main-faq1": "🚗⚡ ¿Qué es un vehículo eléctrico (EV)?",
  "ae-main-faq1A":
    "<p>Un EV es un vehículo que usa electricidad como combustible principal. Puede ser:</p><ul><li><span>Un <strong>Vehículo Eléctrico de Batería (BEV)</strong> que funciona únicamente con electricidad, o </span></li><li><span>Un <strong>Vehículo Eléctrico Enchufable (PHEV)</strong> que usa tanto electricidad como gasolina. </span></li></ul>",

  "ae-main-faq2": "💰 ¿Son más caros los EVs que los autos de gasolina?",
  "ae-main-faq2A":
    "<p>Aunque los EVs pueden tener un costo inicial más alto, son más baratos de operar. Costos de energía más bajos, menos mantenimiento y los incentivos fiscales y subsidios disponibles suelen hacerlos más accesibles a largo plazo.</p>",

  "ae-main-faq3":
    "⚡ ¿Qué son los niveles de carga: Nivel 1, Nivel 2 y carga rápida DC?",
  "ae-main-faq3A":
    "<columns><column><img1></img1><p><strong>Nivel 1</strong></p><ul><li><span>Cargadores que se conectan a un enchufe doméstico estándar de 120 voltios.</span></li><li><span>Tasa de carga lenta: 3-5 millas por hora.</span></li><li><span>Útil para quienes recorren menos de 40 millas diarias.</span></li><li><span>Ideal para cargar durante la noche en casa.</span></li></ul></column><column><img2></img2><p><strong>Nivel 2</strong></p><ul><li><span>Usa 240 voltios, similar al enchufe de una secadora.</span></li><li><span>Tasa de carga media: 15-30 millas por hora.</span></li><li><span>Útil para quienes viajan más de 100 millas al día.</span></li><li><span>Ideal cuando tienes varias horas para cargar.</span></li></ul></column><column><img3></img3><p><strong>Carga rápida DC</strong></p><ul><li><span>Tres tipos de conectores: CHAdeMO, SAE Combo (CCS) y NACS (Tesla).</span></li><li><span>Tasa de carga rápida: 150-400 millas por hora.</span></li><li><span>Útil para viajes de larga distancia (300+ millas).</span></li><li><span>Mejor cuando necesitas cargar en menos de 30 minutos.</span></li></ul></column></columns>",

  "ae-main-faq4": "🔋 ¿Cuánto puedo conducir con una carga completa?",
  "ae-main-faq4A":
    "<img1></img1><p>La mayoría de los EVs hoy ofrecen entre <strong>230 y 350 millas por carga</strong>, lo que cubre <strong>varios días de manejo</strong> para el viajero promedio de Austin (aprox. 25 millas de ida y vuelta por día).</p>",

  "ae-main-faq5": "🏡 ¿Puedo cargar mi EV en casa?",
  "ae-main-faq5A":
    "<p>¡Sí! Una de las mayores ventajas de tener un vehículo eléctrico es poder cargarlo en casa mientras duermes. Aunque puedes enchufarlo a una toma de corriente doméstica de 120 V, un cargador de Nivel 2 (240 V) te ofrece una carga mucho más rápida. Austin Energy ofrece un <a1>reembolso para la instalación de un cargador doméstico Nivel 2</a1>.</p><p>¿Cuándo cargar?<break></break>Todos los vehículos eléctricos tienen temporizadores que permiten programar la carga. Es mejor cargar tu vehículo eléctrico entre las 10 p.m. y las 6 a.m., cuando la energía eólica es más abundante y la red eléctrica tiene mayor capacidad. Se recomienda evitar cargar entre las 4 p.m. y las 7 p.m., cuando la demanda es más alta. <a2>(Departamento de Transporte de Texas)</a2></p><p>➢ Obtén créditos en tu factura por usar tu cargador doméstico durante periodos de baja demanda de energía con <a3>Power Partner℠ EV</a3>.</p>",

  "ae-main-faq6": "🏙️ ¿Qué pasa si vivo en un apartamento o alquilo?",
  "ae.chargeOnTheGo": "Carga sobre la marcha",
  "ae-main-faq6A":
    "<p>¡Aún puedes pasarte a lo eléctrico! <a></a>: Austin Energy ofrece opciones de carga para todos. No se requiere suscripción.</p>",
  "ae-main-faq7": "📍 ¿Dónde puedo encontrar estaciones de carga pública?",
  "ae-main-faq7A":
    "<p>La red de carga EV de Austin Energy incluye miles de estaciones públicas, incluidas cargas rápidas. También hay otras redes disponibles en toda Austin.</p>",

  "ae-main-faq8": "💰📋 ¿Qué incentivos y subsidios están disponibles?",
  "ae.checkCurrentIncentives": "Consulte los incentivos actuales",
  "ae-main-faq8A": "<p><a></a></p>",

  "ae-main-faq9": "🌎 ¿Realmente los EVs son mejores para el medio ambiente?",
  "ae-main-faq9A":
    "<p>Sí. Los EVs no emiten gases por el escape y son más eficientes en general, incluso cuando se cargan con la red eléctrica actual. Ayudan a mejorar la calidad del aire y reducir gases de efecto invernadero.</p>",

  "ae-main-faq10": "🚘 ¿Cómo elijo el EV adecuado para mí?",
  "ae.findYourEvMatch": "Encuentre su vehículo eléctrico ideal",
  "ae-main-faq10A":
    "<p>Utilice la Guía de compra de vehículos eléctricos para comparar modelos según el precio, la autonomía, las características y más. Ya sea que conduzca a diario, comparta coche o busque algo divertido, hay un vehículo eléctrico que se adapta a su vida.</p><p><a></a></p>",
  "ae-main-faq11": "🧰 ¿Qué pasa con el mantenimiento?",
  "ae-main-faq11A":
    "<p>Los vehículos eléctricos tienen menos piezas móviles, no requieren cambios de aceite y presentan menos desgaste en los frenos. Eso significa menos mantenimiento y menores costos a lo largo de su vida útil.</p>",

  "ae-erides-faq1": "✅ Bajo costo, alto valor",
  "ae-erides-faq1A":
    "Las bicicletas y scooters eléctricos cuestan mucho menos que los autos y requieren un mantenimiento mínimo. Sin gasolina, sin cambios de aceite—solo conéctalos y listo.",

  "ae-erides-faq2": "🚦 Supera el tráfico",
  "ae-erides-faq2A":
    "Los E-Rides te ayudan a evitar la congestión y moverte más rápido por los carriles para bicicletas y senderos urbanos.",

  "ae-erides-faq3": "🌎 Opción ecológica",
  "ae-erides-faq3A":
    "Cada viaje en una bicicleta o scooter eléctrico ayuda a reducir las emisiones de carbono y la contaminación del aire—bueno para ti y para Austin.",

  "ae-erides-faq4": "🅿️ Sin estrés al estacionar",
  "ae-erides-faq4A":
    "Olvídate de dar vueltas buscando un espacio o pagar por estacionamiento en el centro. Los E-Rides se pueden guardar en casa o asegurar en cualquier portabicicletas.",

  "ae-erides-faq5": "🔋 Perfecto para viajes cortos",
  "ae-erides-faq5A":
    "Ya sea para ir al trabajo, hacer compras o disfrutar de un paseo escénico por Lady Bird Lake, los E-Rides hacen que los viajes cortos sean divertidos.",

  "evCard.altText": "Ir a {makeModelTrim}",

  faqMainTitle: "Preguntas Frecuentes (FAQs)",
  faqMainDescription:
    "¿Listo para explorar la conducción eléctrica? Esta FAQ ofrece respuestas rápidas sobre carga, costos, incentivos y beneficios para que pueda hacer el cambio con confianza. Con Austin Energy, pasar a lo eléctrico es más fácil y asequible que nunca.",

  dealersHeading: "Concesionarios de Vehículos Eléctricos de Propiedad Local",
  dealersSubheading:
    "Los concesionarios que aparecen a continuación colaboran estrechamente con Austin Energy para brindarte una excelente experiencia de compra de vehículos eléctricos. Contáctalos y visítalos con la confianza de que te ayudarán a elegir el vehículo adecuado para ti.",
  "dealer.contact": "Contacto",
  "dealer.map": "Mapa",
  "dealer.website": "Sitio web",

  personalizeIncentives: "Personalizar Incentivos",

  factsSubheading:
    "¡Los vehículos eléctricos son fáciles! He aquí cinco datos curiosos sobre los vehículos eléctricos.",
  factsUseHeading: "FÁCIL DE USAR",
  factsUseContent:
    "Enchúfelo en una toma de corriente normal en casa o utilice una estación de carga para una carga más rápida.",
  factsMaintain: "FÁCIL DE MANTENER",
  factsMaintainContent:
    "Disfrute de más tiempo y dinero en su bolsillo, ya que los vehículos eléctricos requieren menos mantenimiento y tienen menos piezas móviles.",
  factsCharge: "FÁCIL DE CARGAR",
  factsChargeContent:
    "Cargue por sólo {amount} al mes en cualquiera de los más de 800 puertos de carga locales de Austin Energy, alimentados por energía eólica 100% renovable de Texas.",
  factsDriveEasy: "FÁCIL DE CONDUCIR",
  factsDrivePerformance:
    "Obtenga las altas prestaciones que desea en un automóvil, cuando decida arrendar, comprar o conseguir un VE usado.",
  factsDriveContent: "¡FÁCIL DE ENCONTRAR!",
  factsBrowse:
    "¡Navegue por la nueva Guía del Comprador de {website} para encontrar su vehículo ahora! {link}",
  factsBrowseLink: "Vea lo que dicen los conductores de vehículos eléctricos.",

  "vehicle.miles": "Millas",
  "vehicle.trees": "Árboles",
  "vehicle.view": "Ver",
  "vehicle.more": "más",
  "vehicle.fewer": "menos",
  "vehicle.greater": "más",

  "vehicle.plugInHybrid": "Híbrido Eléctrico Enchufable",
  "vehicle.allElectric": "Eléctricos",
  "vehicle.gas": "Gasolina",
  "vehicle.afterIncentives": "Después de incentivos",
  "vehicle.msrp": "MSRP",
  "vehicle.estimatedIncentives": "Insentivos estimados",
  "vehicle.type": "Tipo",
  "vehicle.fuelType": "Tipo de combustible",
  "vehicle.batterySize": "Tamaño de la batería",
  "vehicle.electricRange": "Rango eléctrico",
  "vehicle.timeToChargeLvlTwo": "Tiempo de carga - Nivel 2",
  "vehicle.milesPerThirtyFastCharge": "Millas por 30 minutos de carga rápida",
  "vehicle.coTwoEmissions": "Reducción de emisiones de CO2",
  "vehicle.phev": "Electricidad y gasolina ",
  "vehicle.bev": "Electricidad",
  "vehicle.age.one": "0-1 Años",
  "vehicle.age.two": "2-3 Años",
  "vehicle.age.four": "4+ Años",

  "vehicle.type.sedan": "Sedan",
  "vehicle.type.hatchback": "Cinco puertas",
  "vehicle.type.coupe": "Cupé",
  "vehicle.type.crossover": "Híbrido",
  "vehicle.type.minivan": "Minivan",
  "vehicle.type.suv": "SUV",
  "vehicle.type.wagon": "Camioneta",
  "vehicle.type.truck": "Camión",

  footerInventory: "Inventario - Guía del comprador de VE de Austin Energy",
  findDealers: "Buscar concesionarios",
  evFAQ: "Preguntas Frecuentes Sobre Los Ve",

  "footer.poweredBy": "Patrocinado por Zappyride",

  "homepage.welcome": "Colton Recharged",
  "homepage.welcomeSub":
    "Su guía para autos eléctricos, diseñada por Colton Electric Utility. Obtenga un estimado y compare costos, opciones de ahorro, incentivos y mucho más para VE.",

  "homepage.linkCard.browseElectricVehicles":
    "VEHICULOS {lineBreak} ELÉCTRICOS",
  "homepage.linkCard.researchElectricVehicles":
    "INVESTIGAR {lineBreak} ELÉCTRICOS",
  "homepage.linkCard.discoverIncentives": "DESCUBRA {lineBreak} INCENTIVOS",
  "homepage.linkCard.locateChargingStations":
    "ENCUENTRE ESTACIONES {lineBreak} DE CARGA",
  "homepage.linkCard.homeChargers": "CARGADORES PARA {lineBreak} EL HOGAR",
  "homepage.linkCard.findDealers": "ENCONTRAR {lineBreak} DISTRIBUIDORES",

  "homepage.vehicleCarousel.title":
    "Existen {vehicleCount} vehículos eléctricos disponibles. Descubra el suyo.",
  "homepage.vehicleCarousel.subTitle":
    "Elija un VE y compare el costo con un vehículo de gasolina similar. Los VE’s le permiten ahorrar dinero porque {lineBreak} son más económicos y baratos de poseer y mantener a comparación de un competidor de 100% gasolina.",
  "homepage.vehicleCarousel.findEVButton": "Encuentre su vehículo eléctrico",

  "homepage.fuelRangeChart.title":
    "Hasta dónde puede conducir el {car} con un {budget} presupuesto de combustible?",

  "graph.assumptions": "Supuestos",
  "graph.yourEV": "VE seleccionado",
  "graph.similarGasVehicle": "Vehículo comparable a gasolina ",
  "graph.graphValues": "VALORES GRAFICADOS",
  "graph.show": "MOSTRAR ",
  "graph.hide": "OCULTAR ",
  "graph.moreExpensive": "mas caro",
  "graph.cheaper": "mas barato",
  "graph.toOwnOver": "de tener por ",
  "graph.years": " Años",
  "graph.year": " Año",

  "graph.costOfOwnership.title": "Costo de Propiedad",
  "graph.costOfOwnership.subTitle":
    "El {carName} es {style} {costDeltaText} {costDeltaTextEnding}",
  "graph.costOfOwnership.subTitleThreeCars":
    "El {carName} es el más barato de tener por {yearsOfOwnership} años",
  "graph.costOfOwnership.descriptionRow.vehicle": "Vehículo",
  "graph.costOfOwnership.descriptionRow.maintenance": "Mantenimiento",
  "graph.costOfOwnership.descriptionRow.insurance": "Seguro",
  "graph.costOfOwnership.descriptionRow.electricity": "Electricidad",
  "graph.costOfOwnership.descriptionRow.gasoline": "Gasolina",
  "graph.costOfOwnership.totalRow": "Total",
  "graph.costOfOwnership.description": "Descripción",

  "graph.costOfOwnership.chart.vehicle": "Incentivos para vehículo, Reventa.",
  "graph.costOfOwnership.chart.electricity": "Electricidad",
  "graph.costOfOwnership.chart.gasoline": "Gasolina",
  "graph.costOfOwnership.chart.maintenance": "Mantenimiento",
  "graph.costOfOwnership.chart.insurance": "Seguro",

  "graph.title.costAnalysis": "Análisis de Costos",
  "graph.title.speedOfCharge": "Velocidad de Carga",
  "graph.title.electricRange": "Rango Eléctrico",
  "graph.monthlyCostToFill.title": "Costo de Llenar el Tanque Mensualmente",

  "graph.speedOfCharge.levelTwoChargingSpeed": "Velocidad de carga Nivel 2",
  "graph.speedOfCharge.fastChargingSpeed": "Velocidad de carga rápida",
  "graph.speedOfCharge.mphLevelTwoCharger":
    "millas por hora al usar un cargador nivel 2 ",
  "graph.speedOfCharge.thirtyFastCharge":
    "millas por cada 30 minutos de carga rápida",
  "graph.speedOfCharge.subTitle":
    "El {car} tendrá {number} {costDeltaText} {subTitleText}",
  "graph.speedOfCharge.mphLevelTwoChargerThreeCars":
    "será el que gane más rango de carga tras una hora de uso de un cargador nivel 2",
  "graph.speedOfCharge.thirtyFastChargeThreeCars":
    "será el que gane más rango de carga después de 30 minutos de carga rápida",
  "graph.speedOfCharge.subTitleThreeCars": "El {car} {subTitleText}",
  "graph.speedOfCharge.mphLevelTwoChargerTitle":
    "Porcentaje de carga por hora en Nivel 2",
  "graph.speedOfCharge.fastChargerTitle":
    "Cantidad de millas por 30 minutos de carga rápida.",
  "graph.electricRange.subTitleThreeCars":
    "El {car} tiene el rango eléctrico más amplio de todos",
  "graph.electricRange.subTitle":
    "El rango eléctrico del {car} tiene {number} millas { costDeltaText} ",
  "graph.electricRange.gasolineRange": "Rango de gasolina",
  "graph.electricRange.assumption": "Rango basado en estimaciones de la EPA",
  "graph.monthlyCostToFill.subTitle":
    "El {carName} es {style} {costDeltaText} de tanquear mensualmente",
  "graph.monthlyCostToFill.subTitleThreeCars":
    "El {carName} el más barato de tanquear mensualmente",

  "homepage.incentives.subTitle":
    "Descubra que tanto puede ahorrar con un VE, ya sea por compra o alquiler. Los incentivos son personalizados para {company} clientas.",
  "homepage.incentives.exporeIncentives": "DESCUBRA INCENTIVOS",
  "homepage.incentives.personalizeIncentivesButton": "Personalizar Incentivos",

  "compareVehicles.subTitle": "Ver todos los vehículos >",
  "compareVehicles.selectFuel": "Seleccione el Tipo de Combustible ",
  "compareVehicles.selectMake": "Seleccione la marca",
  "compareVehicles.selectModel": "Seleccione el modelo",
  "compareVehicles.pickTwo":
    "Elíja al menos 2 vehículos para hacer la comparación",
  "compareVehicles.disclaimer":
    "No todas las marcas / modelos están disponibles.",

  "evs.welcomeSub":
    "Compara autos eléctricos por su rango, precio, o por características que más se acomoden a tu gusto. {lineBreak} Haz click sobre el VE para obtener detalles como el costo total comparado con vehículos de gasolina.",
  "evs.buttonMatchScoreAndFilters": "Puntaje personalizado y Filtros",
  "evs.matchScoreAndFilters": "Asignar puntaje personalizado y Filtros",
  "evs.matchScoreOptions": "Asignar Puntaje Personalizado",
  "evs.roundTripCommute": "Viaje de ida y vuelta",
  "evs.budgetAfterIncentives": "Presupuesto después de incentivos",
  "evs.minSeats": "Cantidad mínima de asientos",
  "evs.seats": "Asientos",
  "evs.homeChargingAvailability": "Disponibilidad de carga en el hogar",
  "evs.homeChargingAvailabilityTooltip":
    "Más autos eléctricos serán mejores para ti si tienes la posibilidad de cargarlos rapidamente en casa.",
  "evs.noCharging": "Sin carga",
  "evs.levelOne": "Nivel 1",
  "evs.levelTwo": "Nivel 2",
  "evs.helpMeChoose": "Ayúdame a elegir",
  "evs.chargingAvailability": "Disponibilidad de carga",
  "evs.disclaimer":
    "Es posible que los vehículos mostrados en esta página no reflejen la disponibilidad real. {company} no respalda ni recomienda ningún modelo o fabricante de vehiculos específico. ",

  vehiclesAvailabilityButton: "Solo vehículos locales",

  "chargingWizard.carOvernight": "¿En dónde parquear tu Auto en la noche?",
  "chargingWizard.parkingGarage": "Garaje privado o estacionamiento",
  "chargingWizard.onTheStreet": "En la calle",
  "chargingWizard.publicParking": "Estacionamiento público",
  "chargingWizard.electricianInstall":
    "¿Puede un electricista instalarme una estación de carga?",
  "chargingWizard.overnightParking":
    "¿Podrías estacionar tu auto en un lugar que cuenta con estación de carga?",
  "chargingWizard.powerOutlet":
    "¿Existe algún tomacorriente cerca al lugar en donde estacionas tu auto?",
  "chargingWizard.chargingAvailability": " Disponibilidad de carga",
  "chargingWizard.noChargingAvailability": "No disponibilidad de carga",
  "chargingWizard.youWouldHave": "Tendrás {resultText} ",
  "chargingWizard.useThisValue": "Usar este valor",

  evfilter: "Filtro",
  "evfilter.fuel": "Combustible",
  "evfilter.fuelTooltip":
    "Los vehículos eléctricos solo usan electricidad. Los vehículos híbridos pueden funcionar con electricidad y gasolina.",
  "evfilter.type": "Tipo",

  yes: "Si",
  no: "No",
  availability: "Disponibilidad",
  "availability-Tooltip":
    "Estos vehículos se han visto en el inventario de concesionarios locales del área de Austin en el pasado reciente.",

  vehiclesFuelTip:
    "Los vehículos eléctricos solo usan electricidad. Los vehículos híbridos pueden funcionar con electricidad y gasolina.",

  "evCard.electricRange": "Rango eléctrico",
  "evCard.totalRange": "Rango total",
  "evCard.matchScore": "Puntaje personalizado",
  "evCard.seeDetails": "DETALLES",
  "evCard.seeElectricVehicle": "Ver Vehículo Eléctrico",

  "graph.fuelRange.chart.description": "Description",
  "graph.fuelRange.chart.rangeOn": "Rango encendido",
  "graph.fuelRange.chart.fuelBudget": "presupuesto de combustible",
  "graph.fuelRange.chart.network": "en la Plug-In EVerywhere network",
  "graph.fuelRange.chart.unlimited": "Ilimitado",
  "graph.fuelRange.chart.chargedHome": "cargado en casa",
  "graph.fuelRange.chart.similarGas": "un vehículo de gas similar",
  "graph.fuelRange.chart.miles": "millas",
  "graph.fuelRange.chart.howFar":
    "Hasta dónde puede conducir el {car} en un {budget} presupuesto de combustible?",

  "evSort.title": "Ordenar por",
  "evSort.matchScore": "Puntaje personalizado",
  "evSort.electricRange": "Rango eléctrico",
  "evSort.priceLtH": "Precio: Menor a mayor",
  "evSort.priceHtL": "Precio: Mayor a menor",
  "evSort.alphabetical": "Orden alfabético",

  inventoryFilter: "Filtro de vehículos",
  inventoryAll: "Todos",
  inventoryNew: "Neuvo",
  inventoryUsed: "Usó",

  "pricePanels.cash": "Efectivo",
  "pricePanels.loan": "Crédito",
  "pricePanels.lease": "Arrendamiento",
  "pricePanels.loanPayment": "Pago del préstamo",
  "pricePanels.downPayment": "Cuota inicial",
  "pricePanels.leasePayment": "Pago de arriendo",
  "pricePanels.perMonth": " / Mes",
  "pricePanels.downPaymentDescription": "10% de MSRP más impuestos",
  "pricePanels.firstLeasePayment": "Primera cuota de la renta",
  "pricePanels.incentivesForLease": "Incentivos para rentar",
  "pricePanels.seeAllIncentives": "Ver todos los incentivos",
  "pricePanels.seeAllCosts": "Ver todos los costos",

  "ev.jumbotron.viewAllCars": "Ver todos los autos",
  "ev.jumbotron.disclaimer":
    "Consulte las páginas {evFacts} y {faq} para obtener explicaciones detalladas sobre su EV.",
  "ev.carDetails.fastChargingTooltip": "Velocidad de carga rápida con DC:",
  "ev.carDetails.levelTwoChargerSpeedTooltip": "Velocidad de carga Nivel 2:",
  "ev.carDetails.batterySizeTooltip":
    "Un Kilovatio por hora (kWh) provee suficiente energía para conducir de 1 a 4 millas dependiendo del vehículo. Una batería común para computadora puede contener menos de 1 kWh",
  "ev.carDetails.treesPlanted": "Árboles plantados",
  "ev.carDetails.gasolineSaved": "Gasolina ahorrada",
  "ev.carDetails.compareText":
    "Seleccionamos el {gasVehicle} por su proximidad con el {vehicle} con base en la marca, tamaño y precio.",
  "ev.cardetails.calc.dcRate": "Cargador Rápido (DCFC)",
  "ev.cardetails.calc.EPA": "Calificación de eficiencia EPA",
  "ev.cardetails.calc.chargingRate": "Velocidad de carga",
  "ev.cardetails.calc.vehicleBatteryCapacity": "Capacidad de la batería",
  "ev.cardetails.calc.maxACIntake": "Capacidad maxima de AC",
  "ev.cardetails.calc.lvlTwoChargingRate": "Velocidad de carga Nivel 2",
  "ev.cardetails.calc.minOflvl2AC":
    "Nivel mínimo de carga y capacidad máxima de absorcion del AC",
  "ev.cardetails.calc.lvl2FullCharge": "Tiempo de carga total en Nivel 2",
  "ev.cardetails.calc.milesDrivenPerYr": "Millas conducidas al año",
  "ev.cardetails.calc.userInput": "Introducción de datos por el usuario",
  "ev.cardetails.calc.milesPerGallon": "Millas por Galón (mpg)",
  "ev.cardetails.calc.mpg": " millas/gal",
  "ev.cardetails.calc.portionElectric": "Porción eléctrica usada",
  "ev.cardetails.calc.portionElectricSource":
    "Introducción de datos por el usuario. Para un vehículo híbrido, estima la porción de millas conducidas usando batería eléctrica en vez de gasolina.",
  "ev.cardetails.calc.gallonsUsed": "Galones Usados",
  "ev.cardetails.calc.gallonsUsedFormula":
    "Millas manejadas * (1 - Porción eléctrica usada) / MPG",
  "ev.cardetails.calc.gallonsSaved": "Galones Ahorrados",
  "ev.cardetails.calc.gallonsSavedFormula":
    "Galones usados por un vehiculo a gasolina comparable - Galones usados por VE",
  "ev.cardetails.calc.electricEmissions":
    "Emisiones por consumo eléctrico en Lbs",
  "ev.cardetails.calc.electricEmissionsLbsMwh":
    "Emisiones de CO2 por consumo eléctrico en lbs/MWh",
  "ev.cardetails.calc.EIA":
    "Administración de información energética de Estados Unidos",
  "ev.cardetails.calc.gasolineEmissionsYr":
    "Emisiones por consumo de gasolina en lbs de CO2/yr",
  "ev.cardetails.calc.gasolineEmissions":
    "Emisiones de CO2 por consumo de gasolina en lbs/gal",
  "ev.cardetails.calc.emissionsReudctions": "Reducción de emisiones",
  "ev.cardetails.calc.lbsCo2PerYr": " lbs de CO2 al año",
  "ev.cardetails.calc.gasolineEmissionsLbs":
    "Emisiones por consumo de gasolina en lbs",
  "ev.cardetails.calc.arborDayFoundation": "Fundación Arbor Day",
  "ev.cardetails.calc.emissionsPerTree":
    "Emisiones capturadas por árbol por año",
  "ev.cardetails.calc.electricityEmissions":
    "Emisiones de CO2 por consumo eléctrico en lbs/MWh",
  "ev.usedCarTitle": "{car} Usado",
  "ev.cardetails.electricRange":
    "To account for battery degradation, the range quoted here is an estimation based on the age of the vehicle and normal driving/charging patterns.",
  "ev.carDetails.usedBatterySizeTooltip":
    "One kilowatt-hour (kWh) is enough energy to drive 1 to 4 miles, depending on the vehicle. To account for battery degradation for a used EV, the battery size quoted here is an estimation based on the age of the vehicle and normal driving/charging patterns.",

  "ev.purchaseMethod": "Forma de pago",
  "ev.purchaseMethodToolTip":
    "En modo renta, usted tiene que devolver el auto al final del periodo de arrendamiento. En el caso de financiación con un crédito, usted se queda con el auto al terminar de pagar el crédito.",
  "ev.cash": "Efectivo",
  "ev.loan": "Crédito",
  "ev.lease": "Renta",
  "ev.milesDrivenAnnually": "Millas conducidas por año",
  "ev.electricPortion": "Parte eléctrica de un PHEV",
  "ev.electricPortionTooltip":
    "A Plug-In Hybrid Electric Vehicle (PHEV) can use both electricity and gasoline. It is usually more beneficial to use electricity.",
  "ev.yearsOwnership": "Compra/renta al año",
  "ev.interestRate": "Tasa de interés",
  "ev.electricityRateCalc":
    "Electricity rate is calculated as a blended rate based off an average household consumption of 700 kWh. To learn more, please click {website}",

  "assumption.salesTax": "Impuesto a las ventas",
  "assumption.gasolinePrice": "Precio de gasolina",
  "assumption.downPayment": "Cuota inicial",
  "assumption.electricityRate": "Rango eléctrico",
  "assumption.downPaymentValue": "10% de MSRP más impuestos",

  "ev.compareGasVehicle":
    "Compare el {car} con un vehículo similar a gasolina, el {gasCar}.",
  "ev.compareOtherVehicles": "COMPRE OTHER VEHICLES",
  "ev.incentives.title":
    "Hasta {savings} en créditos fiscales y reembolsos están disponibles {lineBreak} para el {car}.",
  "ev.reviews": "Reseñas en la web",

  "chargingMap.updateZipcode": "Actualizar Código Postal",
  "chargingMap.errorZipcode":
    "Error: {workingZipcode} no es un código postal válido",
  "chargingMap.showFullListOfStations": "lista completa de estaciones",
  "chargingMap.public": "Estaciones Públicas",
  "chargingMap.businessGovernment": "Instaladas por empresas o el gobierno",
  "chargingMap.highPowerStations": "Estaciones de Alta Potencia",
  "chargingMap.DCChargers": "Carga rápida CC o súper-cargadores",
  "chargingMap.otherSttations": "Otros Tipos de Estaciones",
  "chargingMap.privateStations": "Estaciones rivadas",
  "chargingMap.searchDealers": "Buscar Distribuidores Calificados",

  "dealers.brands": "Marcas",
  "dealers.allBrands": "Todos las Marcas",
  "dealers.allDealers": "Todos los Distribuidores",
  "dealers.contact": "CONTACTO",
  "dealers.website": "SITIO WEB",
  "dealers.findDealers": "Encontrar Distribuidores",

  "incentives.title": "Incentivos para Vehículos Eléctricos",
  "incentives.subTitle":
    "Usted puede ser elegible para un rango de incentivos, incluyendo reembolsos, créditos fiscales y otros beneficios. Los incentivos son personalizados según su lugar de residencia.",
  "incentives.single": "Soltero",
  "incentives.married": "Casado",
  "incentives.headOfHousehold": "Cabeza de hogar",
  "incentives.vehicleType": "Tipo de vehículo",
  "incentives.vehicleTypeTooltip":
    "Ciertos incentivos dependen de qué carro compres.",
  "incentives.tradeIn": "Intercambio",
  "incentives.income": "Estado de ingresos e impuestos",
  "incentives.incomeTooltip":
    "La elegiblidad para incentivos y la cantidad que puedes recibir depende normalmente de tu nivel de ingresos. Clientes con niveles de ingresos menores son usualmente elegibles para reembolsos mayores.",
  "incentives.clunkerNone":
    "Ciertos incentivos te compensan por retirar un vehículo existente, también conocido como carro viejo.",
  "incentives.clunkertoolTip":
    "Ciertos incentivos te compensan por retirar un vehículo existente, también conocido como carro viejo.",
  "incentives.clunkertoolTipContd":
    " Están disponibles en tu región. Los requisitos para elegibilidad varían por incentivo, por favor revise los detalles del programa.",
  "incentives.householdSize": "Tamaño del Hogar",
  "incentives.householdIncome": "Ingresos del Hogar",
  "incentives.planClunker": "¿Estás planeando intercambiar tu carro viejo?",
  "incentives.location": "Ubicación",
  "incentives.locationTooltip":
    "Muchos incentivos dependen del lugar en el que vives. Por favor ingresa tu código zip para ayudarte a determinar cuáles incentivos están disponibles en tu lugar de residencia.",
  "incentives.taxFilingStatus": "Estado Civil para Efectos de la Declaración",
  "incentives.whichVehicle": "¿Qué vehículo planeas comprar?",
  "incentives.incentiveEligibility": "Actualizar Elegibilidad para Incentivos",

  "erides.bigPromise.title": "Ahorra dinero. Conduce eléctrico.",
  "erides.bigPromise.description":
    "Austin Energy ofrece reembolsos para ayudarte a comprar bicicletas eléctricas, scooters, ciclomotores y otros vehículos eléctricos de dos o tres ruedas que sean elegibles.",
  "eRides.rebate.description":
    "Todas las compras deben realizarse a través de un {link} para calificar.",
  "eRides.rebate.description.link": "concesionario local elegible",

  "eRides.rebates.oneTitle": "Para clientes individuales",
  "eRides.rebates.twoTitle": "Para participantes en el {link}",
  "eRides.rebates.two.title.link": "Programa de Asistencia al Cliente (CAP)",
  "eRides.rebates.threeTitle":
    "Para clientes de flotas que compren de 5 a 25 E-Rides",
  "eRides.upTo": "Hasta",
  "eRides.vehicle": "por vehículo*",

  "erides.faqTitle": "Por qué los E-Rides son una inversión inteligente",
  "erides.faqDescription":
    "Los E-Rides son más que diversión: son una forma práctica y económica de moverse por Austin.",

  "erides.readyToRide.title": "¿Listo para conducir?",
  "erides.readyToRide.description":
    "Comienza a ahorrar hoy. Encuentra un {link} y solicita tu reembolso.",
  "erides.readyToRide.link": "concesionario elegible",

  "eRides.rebate.button": "Consulta las ofertas de reembolso y solicita ahora",

  "eRides.rebate.title": "¿Cuánto puedes ahorrar?",

  "erides.bikemap.faqTitle": "Muévete por Austin — a tu manera",
  "ae-erides-bikemap-faq2": "🚴 Prueba una bicicleta eléctrica ⚡",
  "ae-erides-bikemap-faq2A":
    "¿Aún no estás listo para comprar? No hay problema. {link} te permite alquilar una bicicleta eléctrica para recorrer el centro de Austin.",
  "ae-erides-bikemap-faq2-link": "Bikeshare",

  "erides.wantToRide":
    "¿Quieres andar en eléctrico además de conducir? Consulta la {link}.",
  "erides.wantToRide.link": "página de E-Ride",
  "homepage.incentives.title":
    "Incentivos y Créditos Fiscales para Vehículos Eléctricos",
  "homepage.incentives.subtitle":
    "Descubre cuánto podrías ahorrar en un vehículo eléctrico.",
  "homepage.incentives.cta":
    "¿Vives en un edificio de apartamentos? Propietarios e inquilinos, <a1>obtengan más información</a1> sobre nuestro reembolso por estaciones de carga para vehículos eléctricos Plug-in Austin.",

  "homeChargers.subText":
    "Seleccione el vehículo que le interesa para ver los detalles de tiempo de carga total de la bateria.",
  "homeChargers.wallMounted": "Montaje en pared",
  "homeChargers.portable": "Portátil",
  "homeChargers.price": "Precio",
  "homeChargers.cordLength": "Longitud del cable",
  "homeChargers.wifi": "Conectividad Wifi",
  "homeChargers.socket": "Enchufe",
  "homeChargers.socketTooltip":
    "Cada modelo de cargador tiene un patrón de enchufe diferente. Estos tipos de patrón corresponden a la forma en la que las puntas encajan en la toma de corriente de la pared. Si no está seguro de cuál es el mejor para su hogar/garaje, consulte con un electricista calificado..",
  "homeChargers.cordLengthLtH": "Longitud del cable: Menor a mayor",
  "homeChargers.cordLengthHtL": "Longitud del cable: Mayor a menor",
  "homeChargersCard.buy": "Detalles y Compra",
  "homeChargersCard.beforeIncentives": "Antes de incentivos",
  "homeChargersCard.socket": "Enchufe {socket}",
  "homeChargers.cable": "Cable de {length} ft.",
  "homeChargers.hardwired": "Cableado Enchufe",
  "homeChargers.toFullCharge": "para carga completa",

  pages: "Páginas",

  footerNavigationOtherResources: "Otros recursos energéticos en Austin",
  footerNavigationEVPrograms: "Programas de VE de Austin Energy",
  footerNavigationSolar: "Solar",
  footerNavigationGreenChoice: "GreenChoice®",
  footerNavigationGreenBuilding: "Edificio ecológico de Austin Energy",
  footerNavigationRebatesIncentives: "Rebajas e incentivos",
  footerNavigationContact: "Contacto",

  "electricians.residential": "Residencial",
  "electricians.commercial": "Comercial",
  "electricians.industrial": "Industrial",
  "electricians.type": "Tipo de Electricista",
  "electricians.searchElectricians": "Buscar Electricistas Calificados",

  "activate.membership": "Activa tu",

  "footer.customerServices": "Servicio al cliente",
  "footer.phoneMain": "512-494-9400",
  "footer.outsideAustin": "Fuera de Austin llame gratis",
  "footer.phoneTollFree": "888-340-6465",
  "footer.contactUs": "Contáctenos",
  "footer.cityUtilities": "Servicios públicos de la ciudad de Austin en línea",
  "footer.startService": "Iniciar/Administrar servicio",
  "footer.billingPayment": "Facturación y pago",
  "footer.billDisputes": "Disputas de facturas",

  "footer.disabilityAssist": "Asistencia por discapacidad",
  "footer.vrsCalls": "Se aceptan llamadas VRS",
  "footer.requestAccommodations": "Solicitar alojamiento",

  "footer.reportOutages": "Informar sobre interrupciones",
  "footer.outagePhone": "512-322-9100",
  "footer.viewOutages": "Ver cortes de luz en línea",
  "footer.reportOutage": "Informar sobre una interrupción y ver el estado",
  "footer.outageAlerts": "Alertas de cortes de suministro",

  "footer.renewableEnergy": "Energía renovable",
  "footer.greenChoice": "Energía eólica GreenChoice®",
  "footer.solar": "Energía solar para el hogar o el negocio",
  "footer.electricVehicles": "Vehículos eléctricos",

  "footer.helpHighBills": "Ayuda con facturas altas",
  "footer.manageEnergy": "Gestione sus costes energéticos",
  "footer.customerAssistPrograms": "Programas de asistencia al cliente",
  "footer.weatherization": "Asistencia para la climatización",

  "footer.energyEfficiency": "Eficiencia energética",
  "footer.rebates": "Reembolsos e incentivos",
  "footer.greenBuilding": "Edificio verde",
  "footer.ecad": "Ordenanzas y auditorías energéticas de la ECAD",

  "footer.spotlight": "En el punto de mira",
  "footer.austinUtilitiesNow": "Servicios públicos de Austin ahora",

  "footer.aboutAE": "Acerca de Austin Energy",
  "footer.whoWeAre": "Quienes somos",
  "footer.history": "Nuestra historia",
  "footer.reports": "Informes corporativos",
  "footer.news": "Noticias",
  "footer.careers": "Carreras",

  "footer.electricRates": "Tarifas de electricidad",
  "footer.residentialRates": "Tarifas residenciales",
  "footer.commercialRates": "Tarifas comerciales",

  "footer.initiatives": "Iniciativas y divulgación",
  "footer.environment": "Ambiente",
  "footer.communitySchools": "Comunidad y escuelas",

  "footer.safety": "Seguridad",
  "footer.callBeforeDig": "Llama al 8-1-1 antes de excavar",
  "footer.electricalSafety": "Seguridad eléctrica",
  "footer.safetyDuringOutage": "Seguridad durante cortes de energía",
  "footer.treeTrimming": "Servicios de poda de árboles",

  "footer.commercialIndustrial": "Comercial e industrial",
  "footer.commercialApp": "Aplicación web comercial",
  "footer.multifamilyProgram": "Programa de Asociación Multifamiliar",
  "footer.districtEnergy": "Energía y refrigeración de distrito",
  "footer.energyProfiler": "Perfilador de energía en línea",
  "footer.electricDesignCriteria": "Criterios de diseño eléctrico y ESPA",

  "footer.followUs": "Síganos.",

  "footer.disclaimerText":
    "Figures shown on this page are estimates based on data provided by third-parties. This material is provided for informational purposes only and should not be relied on for tax, legal, or financial advice. Neither J.D. Power® nor Austin Energy provides tax, legal or financial advice. You should independently verify the estimates provided here before engaging in any transaction.",
  "footer.allRights": "Todos los derechos reservados.",
  "translate-link-english": "Inglés",
  "translate-link-spanish": "Español",
};
